<ng-template [ngIf]="showStartSign">

<!-- //StartSign -->
<div>
<div class="centerTxt txtBlkShadow">
    <p>
      {{ currentMontName }} starts in {{ preSignName }}
      <button (click)="toggleMonthSigns()"  style="margin-right: 5px;" mat-raised-button>Show Ending Sign</button>
      <button (click)="changeViewMode()" mat-raised-button>Show Starting & Ending Sign</button>
    </p>
  </div>

<div class="sign1_Sign_Container txtBlkShadow">

  <div class="zodiacMainIcon inline BOS">
    <div class="block iconBlkGlow">
      {{ preDayIcon }}
      <button class="block button buttonTxt" (click)="signProfile(preSignName)"  [style.background-color]="preColor ? 'rgb(' + preColor + ')' : 'unset'" mat-raised-button>See the {{ preSignName }} Profile</button>
    </div>
</div>

<div class="spacer"></div>

  <div class="signIcons inline">
    <div class="itemDetail">
      <div class="inline BOS icon">{{ preGlyph }}</div>
      <p class="inline iconTxt">{{ preShortDescription }}</p>
    </div>
    <div class="itemDetail">
      <div class="inline BOS icon">{{ preElement }}</div>
      <p class="inline iconTxt">{{ preElementName }} Element</p>
    </div>
    <div class="itemDetail">
      <div class="inline BOS icon">{{ preQuality }}</div>
      <p class="inline iconTxt">{{ preQualityName }} Energy</p>
    </div>
    <div class="itemDetail">
      <div class="inline BOS icon">{{ preHouse }}</div>
      <p class="inline iconTxt">Lord of House {{ preHouseName }}</p>
    </div>
    <div class="itemDetail">
      <div class="inline BOS icon">{{ prePlanet }}</div>
      <p class="inline iconTxt">Ruled by {{ prePlanetName }}</p>
    </div>
  </div>
</div>
</div>
</ng-template>

<ng-template [ngIf]="!showStartSign">

<!-- //EndSign -->
<div>
    <div class="centerTxt txtBlkShadow">
        <p>
          {{ currentMontName }} ends in {{ postSignName }}
          <button (click)="toggleMonthSigns()"  style="margin-right: 5px;" mat-raised-button>Show Starting Sign</button>
          <button (click)="changeViewMode()" mat-raised-button>Show Starting & Ending Sign</button>
      </p>
      </div>
    
    <div class="sign1_Sign_Container txtBlkShadow">
    
      <div class="signIcons inline">
        <div class="itemDetail">
          <div class="inline BOS icon">{{ postGlyph }}</div>
          <p class="inline iconTxt">{{ postShortDescription }}</p>
        </div>
        <div class="itemDetail">
          <div class="inline BOS icon">{{ postElement }}</div>
          <p class="inline iconTxt">{{ postElementName }} Element</p>
        </div>
        <div class="itemDetail">
          <div class="inline BOS icon">{{ postQuality }}</div>
          <p class="inline iconTxt">{{ postQualityName }} Energy</p>
        </div>
        <div class="itemDetail">
          <div class="inline BOS icon">{{ postHouse }}</div>
          <p class="inline iconTxt">Lord of House {{ postHouseName }}</p>
        </div>
        <div class="itemDetail">
          <div class="inline BOS icon">{{ postPlanet }}</div>
          <p class="inline iconTxt">Ruled by {{ postPlanetName }}</p>
        </div>
      </div>

<div class="spacer"></div>

      <div class="zodiacMainIcon inline BOS">
        <div class="block iconBlkGlow">
          {{ postDayIcon }}
          <button class="block button buttonTxt"  (click)="signProfile(postSignName)"  [style.background-color]="postColor ? 'rgb(' + postColor + ')' : 'unset'" mat-raised-button>See the {{ postSignName }} Profile</button>
        </div>
      </div>
    </div>
    </div>
</ng-template> 

<!-- 
  <div class="centerContainer centerTxt ">
    <div class="inline">
        <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
    </div >
  
    <div class="inline">
      <p class="monthName txtBlkShadow">{{currentMontName}} 2021</p>
    </div>
    
    <div class="inline">
      <button (click)="nextMonth()" mat-raised-button>Next Month</button>
    </div>
  
  </div> -->

  <div class="mobile1-3">
    <div class="centerContainer centerTxt">
      
      <div class="inline txtBlkShadow">
      <p class="monthName txtBlkShadow" mat-raised-button>{{currentMontName}} 2022</p>
        
      </div>
    </div>
    
    <div class="centerContainer centerTxt">
      <div class="inline">
        <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
      </div>
    
      <div class="inline">
        <button (click)="nextMonth()" mat-raised-button>Next Month</button>
      </div>
    </div>
    </div>
    
    <div class="mobile4-retina">
    <div class="centerContainer centerTxt">
      
      <div class="inline">
        <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
      </div>
    
      <div class="inline txtBlkShadow">
      <p class="monthName txtBlkShadow" mat-raised-button>{{currentMontName}} 2022</p>

      </div>
    
      <div class="inline">
        <button (click)="nextMonth()" mat-raised-button>Next Month</button>
      </div>
    </div>
    </div>